/* unplugin-vue-components disabled */import { render } from "./glpInstructions01.vue?vue&type=template&id=69ca1bad&scoped=true"
import script from "./glpInstructions01.vue?vue&type=script&lang=js"
export * from "./glpInstructions01.vue?vue&type=script&lang=js"

import "./glpInstructions01.vue?vue&type=style&index=0&id=69ca1bad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ca1bad"]])

export default __exports__